import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay, 
  cibCcAmex
} from '@coreui/icons'
import {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
} from '@coreui/icons'
import {
  cilArrowRight,
  cilBan,
  cilBasket,
  cilBell,
  cilCalculator,
  cilCalendar,
  cilCash,
  cilCloudDownload,
  cilClone,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronTop,
  cilCheckCircle,
  cilCommentSquare,
  cilCursor,
  cilCog,
  cilContact,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMoon,
  cilOptions,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilSettings,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilXCircle,
  cilBriefcase,
  cilDoubleQuoteSansLeft,
  cilHome,
  cilInfo,
  cilChevronCircleDownAlt,
  cilPlus,
  cilAddressBook,
  cilClipboard,
  cilShareAlt,
  cilTrash,
  cilChevronRight,
  cilChartLine,
  cilReload,
  cilLoopCircular,
  cilHistory,
  cilListRich,
  cilChart,
  cilClock,
  cilHeart,
  cilArrowCircleRight,
  cilCalendarCheck,
  cilArrowTop,
  cilCaretTop,
  cilEducation,
  cilAvTimer,
  cilX,
  cilArrowThickRight,
  cilPaperPlane,
  cilPhone,
  cilInput,
  cilNotes,
  cilArrowLeft,
  cilCart,
  cilMoney,
  cilSpreadsheet,
  cilUserPlus,
  cilFindInPage,
  cilWifiSignal4,
  cilSchool,
  cilWallet,
  cilPrint,
  cilDelete,
  cilSync,
  cilBook

} from '@coreui/icons'
import { logo } from './logo'

export const iconsSet = Object.assign(
  {},
  { logo },
  {
    cilArrowRight,
    cilBan,
    cilBasket,
    cilBell,
    cilCalculator,
    cilCalendar,
    cilCash,
    cilCloudDownload,
    cilClone,
    cilChartPie,
    cilCheck,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilCommentSquare,
    cilCursor,
    cilCog,
    cilContact,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMoon,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilXCircle,
    cilBriefcase,
    cilDoubleQuoteSansLeft,
    cilHome,
    cilInfo,
    cilChevronCircleDownAlt,
    cilPlus,
    cilAddressBook,
    cilClipboard,
    cilShareAlt,
    cilChartLine,
    cilReload,
    cilLoopCircular,
    cilHistory,
    cilTrash,
    cilChevronRight,
    cilListRich,
    cilChart,
    cilClock,
    cilHeart,
    cilArrowCircleRight,
    cilCalendarCheck,
    cilArrowTop,
    cilCaretTop,
    cilEducation,
    cilAvTimer,
    cilX,
    cilArrowThickRight,
    cilPaperPlane,
    cilPhone,
    cilInput,
    cilNotes,
    cilArrowLeft,
    cilCart,
    cilMoney,
    cilSpreadsheet,
    cilUserPlus,
    cilFindInPage,
    cilWifiSignal4,
    cilSchool,
    cilWallet,
    cilPrint,
    cilDelete,
    cilSync,
    cilBook
  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl
  },
  {
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibStackoverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard, 
    cibCcVisa, 
    cibStripe, 
    cibPaypal, 
    cibGooglePay,
    cibCcAmex
  }
)
